





























































































import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
import * as utils from "@/components/util/utils";
@Component
export default class HelloWorld extends myVue {
    my_open(){
        this.current.btn_save=true
        this.current.open()
    }
    my_close(){
        this.current.close()
    }
    get progress (){
        let progress2 = 0
        if (this.current.value.length !== 0) {
            progress2 = Math.ceil((this.current.success_num + this.current.fail_num )* 100 / this.current.value.length)
        }
        return progress2
    }
    get tableData(){
        let newList = []
        let length = this.current.value.length
        this.current.page_total = length
        let index = this.current.page_rows * (this.current.page_page - 1)
        if (length < index) {
            index = 0
        }
        for (let i = 0; i < this.current.page_rows; i++) {
            if (length > index + i) {
                newList.push(this.current.value[index + i])
            }
        }
        return newList
    }

    download () {
        utils.myDownload({fileName: this.current.template_name, apiName_download: this.current.template_url})
    }
    handleSizeChange (val:any) {         // 更新查询的行数
        this.current.page_rows = val
    }
    handleCurrentChange (val:any) {            // 更新查询的页数
        this.current.page_page = val
    }
    handleRemove (file:any, fileList:any) {
        this.current.fileList = []
        for (let l = 0; l < fileList.length; l++) {
            this.current.fileList.push(fileList[l])
        }
    }
    handlePreview (file:any) {
    }
    su (response:any, file:any, fileList:any) {
        this.current.success_num = 0
        this.current.fail_num = 0
        this.current.estimate_fail_num = 0
        var params = new URLSearchParams()
        let setting = []
        for(let i=0;i<this.current.components.template.length;i++){
            setting.push( { type: "String",copy: true,name: this.current.components.template[i].label, field: this.current.components.template[i].name})
        }
        this.current.sett.setting = setting
        this.current.sett.num = 2
        this.current.sett.auto = true
        params.append("set", JSON.stringify(this.current.sett))
        params.append("url", file.response.list[0].url)
        let that = this
        utils.my_post({apiName: "/api/execl/readExecl",
            params: params,
            ok: (json:any, dataAll:any) => {
                this.current.value = json
                if(that.current.initCheck){
                    that.check ()
                }
            }})
    }
    check () {
        var params = new URLSearchParams()
        let that = this
        params.append("json_batch", this.current.valueFormat())
        utils.my_post({api:{url: this.current.data.checkUrl},params: params,
            ok: (json:any, dataAll:any) => {
                that.progressBarCheck({okList:json.okList,errList:json.errList})
            },
            err: (json:any, dataAll:any) => {
                that.progressBarCheck({okList:json.okList,errList:json.errList})
            }})
    }
    progressBarCheck(obj:any){
        let errList = obj.errList;
        for(let i = 0; i < errList.length; i++){
            if(this.current.value[errList[i]].save_state != -2){
                this.current.estimate_fail_num = this.current.estimate_fail_num + 1
            }
            this.current.value[errList[i]].save_state = -2
        }
    }
    save () {
        this.current.btn_save = false
        let oldValue = JSON.parse(this.current.valueFormat())
        let newList = []
        for (let i = 0; i < oldValue.length; i++) {
            oldValue[i].index_123=i;
            newList.push(oldValue[i])
        }
        var params = new URLSearchParams()
        params.append("json_batch", JSON.stringify(newList))
        let that = this
        utils.my_post({apiName:this.current.apiName_save,
            params: params,
            ok: (json:any, dataAll:any) => {
                this.reQuery()
                that.progressBar({okList:json.okList,errList:json.errList})
            },err: (json:any, dataAll:any) => {
                that.progressBar({okList:json.okList,errList:json.errList})
            }})
    }
    progressBar(obj:any){
        let okList = obj.okList;
        let errList = obj.errList;
        for(let i = 0; i < okList.length; i++){
            if(this.current.value[okList[i]].save_state != 1){
                this.current.success_num = this.current.success_num + 1
            }
            this.current.value[okList[i]].save_state = 1
        }
        for(let i = 0; i < errList.length; i++){
            if(this.current.value[errList[i]].save_state != -1){
                this.current.fail_num = this.current.fail_num + 1
            }
            this.current.value[errList[i]].save_state = -1
        }
    }
}
